import Image from 'next/image'

import Box from '@totallymoney/ui/components/Box'
import Flex from '@totallymoney/ui/components/Flex'
import Heading from '@totallymoney/ui/components/Heading'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'

import UnscoredCategoryPageButton from '../UnscoredCategoryPageButton'
import { providersList } from './lib/providersList'

const UnscoredCategoryPageProvidersSection = () => (
    <Stack gridColumn={['1/13', '1/13', '2/12']} space="space80">
        <Stack space="space30" gridColumn="1/13">
            <Heading variant="100" textAlign="center">
                Compare credit cards from top lenders
            </Heading>

            <Text color="light" textAlign="center" variant="120">
                We work with leading lenders to help you find your best options.
                Our average APR for credit cards is 38.4% APR representative
                (variable).
            </Text>
        </Stack>

        <Flex flexWrap="wrap" gridGap="space30" justifyContent="center">
            {providersList.map(({ altText, src }, i) => (
                <Box key={`${altText}-${i}`} overflow="hidden">
                    <Box
                        height={[44, 72]}
                        width={[88, 144]}
                        position="relative"
                    >
                        <Image
                            src={src}
                            alt={altText}
                            priority={false}
                            placeholder="empty"
                            sizes="20vw"
                            quality={60}
                            fill
                            style={{ objectFit: 'contain' }}
                        />
                    </Box>
                </Box>
            ))}
        </Flex>

        <Flex justifyContent="center">
            <UnscoredCategoryPageButton />
        </Flex>
    </Stack>
)

export default UnscoredCategoryPageProvidersSection
